<div class="dialog-padding feedback-dialog">
<h1>Submit Feedback</h1>
<div mat-dialog-content class="feedback-popup">
  <form [formGroup]="feedbackForm">
    <div style="width: 100%;" class="formcontrol">
      <span class="module-lable">Module</span>
      <mat-form-field class="choosemoduleDiv">
       
          <mat-label class="choosemod">Choose Module</mat-label>
          <mat-select formControlName="app_feedback_topic">
            <mat-option *ngFor="let type of feedbackTypes" [value]="type">{{type}}</mat-option>
          </mat-select>
          <mat-error *ngIf="feedbackForm.get('app_feedback_topic').hasError('required')">Type is required</mat-error>
        </mat-form-field>
        
      <mat-label class="rating-heading">How was the module?*</mat-label>
      <mat-radio-group formControlName="feedback_metadata_id">
          <mat-radio-button *ngFor="let option of feedbackOptions" [value]="option.feedback_metadata_id">
            {{ option.feedback_value }}
          </mat-radio-button>
          <mat-error  class="err-msg" *ngIf="feedbackForm.get('feedback_metadata_id').hasError('required') && feedbackForm.get('feedback_metadata_id').touched">
            You must select an option.
          </mat-error>
      </mat-radio-group>
  
      <mat-form-field class="entercomments textarea-field" appearance="fill">
        <mat-label>Enter comments</mat-label>
        <textarea matInput formControlName="app_feedback_description"></textarea>
        <mat-error *ngIf="feedbackForm.get('app_feedback_description').hasError('required')">Description is required*</mat-error>
      </mat-form-field>
    </div>
  
  </form>
</div>
<div mat-dialog-actions>
  <button class="btn-white" mat-button (click)="onCancel()">Cancel</button>
  <button class="btn-red" mat-button (click)="onSubmit()" [disabled]="isSubmitted">Submit</button>
</div>
</div>